import { linkDefaults } from "@/modules/billing/paymentMethodDefaults.tsx";
import type { LinkMethod } from "@/modules/billing/paymentMethods.ts";
import SslcommerzPaymentForm from "@/modules/billing/sslcommerz/SslcommerzPaymentForm.tsx";
import type { ProcessorConfig } from "@warrenio/api-spec/spec.oats.gen";

export function makeSslcommerzLink(config: ProcessorConfig & { type: "link" }) {
    return config.methods.map((method): LinkMethod => {
        const base = linkDefaults(config, method);
        return {
            ...base,
            PaymentForm: (props) => <SslcommerzPaymentForm {...props} method={method} config={config} />,
        };
    });
}
